import { isAppStateReady } from '$appStore'
import { defer } from 'react-router-dom'

/**
 * Loader for the Manage Users page.
 */
export default async function loader() {
  // Gates the page until the app context is ready so we can use the values from
  // that without having to check for readiness.
  await isAppStateReady()

  return defer({ data: Promise.resolve(true) })
}
